module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-monthly.1653fb7b.svg";